// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__cqRIr","textContent":"styles_textContent___Nnd_","sm":"styles_sm__whdiU","md":"styles_md__Kf2Kd"};